import React, { useState } from "react";
import { GiSwan } from "react-icons/gi";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import configData from "../../config.json";
import {
  Button,
  CircularProgress,
  Paper,
  MenuItem,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { useNavigate, useParams } from "react-router-dom";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "../../utils/auth"

function MissingReportSingleDevice({ device }) {
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const params = useParams();
  const navigate = useNavigate();
  const [songTrigger, setSongTrigger] = useState(null);
  const [swanMessage, setSwanMessage] = useState("Trigger swan song");
  const [messages, setMessages] = useState([
    "Trigger swan song",
    "Trigger search wifi networks",
  ]);
  const [openSwan, setOpenSwan] = useState(false);
  const handleClickOpenSwan = () => {
    setOpenSwan(true);
  };

  const handleCloseSwan = () => {
    setOpenSwan(false);
  };
  const handleSwanSongClick = () => {
    setSongTrigger({ response: "Loading" });
    setOpenSwan(false);
    const token = getToken()
    let device_id = device.serial_number;
    let newBody = {
      tablets: [device_id],
      message: swanMessage,
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/Trigger/SwanSong`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setSongTrigger(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const handleSeeResultClick = () => {
    navigate(`/SwanSong/` + device.serial_number);
  };
  //Beacon trigger functions
  const [beaconUuid, setBeaconUuid] = useState(null);
  const [beaconLoading, setBeaconLoading] = useState(false);
  const [beaconStatus, setBeaconStatus] = useState(null);
  const [beaconDialog, setBeaconDialog] = useState(false);
  const triggerDeviceBeacon = () => {
    setBeaconLoading(true);
    const token = getToken()
    let device_id = device.serial_number;
    let newBody = {
      tablets: [device_id],
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/Trigger/Beacon`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.response === "Success") {
          setBeaconLoading(false);
          let message = "Beacon was triggered on " + device_id;
          notify(message, "success");
          setBeaconUuid(data);
          setBeaconStatus("Success");
        } else {
          setBeaconLoading(false);
          notify(data.response, "error");
          setBeaconStatus("Error");
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const beaconOpenDialog = () => {
    setBeaconDialog(true);
  };
  const beaconCloseDialog = () => {
    setBeaconDialog(false);
  };
  //wifi networks
  const [openWifiNetworks, setOpenWifiNetworks] = useState(false);
  const handleOpenWifiNetworks = () => {
    setOpenWifiNetworks(true);
  };

  const handleCloseWifiNetworks = () => {
    setOpenWifiNetworks(false);
  };
  return (
    <TableRow>
      <TableCell>
        <strong>{device.serial_number}</strong>
        <br />
        <span
          style={{
            color: device.battery_status === "CHARGING" ? "green" : "red",
          }}
        >
          {device.battery}%
        </span>
      </TableCell>
      <TableCell align="center">
        <span
          className="material-symbols-outlined"
          style={{
            color: "#1976d2",
            display: "inline-block",
            padding: "0.5rem",
            borderRadius: "4px",
            background: "#fff",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#f0f0f0";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
          }}
          onClick={handleOpenWifiNetworks}
        >
          wifi
        </span>
        <Dialog open={openWifiNetworks} onClose={handleCloseWifiNetworks}>
          <DialogTitle>WiFi networks for {device.serial_number}</DialogTitle>
          <DialogContent>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <strong>Network Name</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>Signal Strength</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {device.wifi.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell align="center">{row.ssid}</TableCell>
                      <TableCell align="center">
                        {" "}
                        {row.level < -80 ? (
                          <>
                            {" "}
                            <span
                              className="material-symbols-outlined"
                              style={{
                                color: "red",
                              }}
                            >
                              signal_wifi_0_bar
                            </span>{" "}
                            <span>{row.level}</span>
                          </>
                        ) : row.level >= -80 && row.level < -70 ? (
                          <>
                            {" "}
                            <span
                              className="material-symbols-outlined"
                              style={{ color: "orange" }}
                            >
                              network_wifi_1_bar
                            </span>
                            <span>{row.level}</span>
                          </>
                        ) : row.level >= -70 && row.level < -67 ? (
                          <>
                            {" "}
                            <span
                              className="material-symbols-outlined"
                              style={{ color: "yellow" }}
                            >
                              network_wifi_2_bar
                            </span>
                            <span>{row.level}</span>
                          </>
                        ) : row.level >= -67 && row.level < -30 ? (
                          <>
                            {" "}
                            <span
                              className="material-symbols-outlined"
                              style={{ color: "lime" }}
                            >
                              network_wifi_3_bar
                            </span>
                            <span>{row.level}</span>
                          </>
                        ) : (
                          <>
                            {" "}
                            <span
                              className="material-symbols-outlined"
                              style={{ color: "green" }}
                            >
                              signal_wifi_4_bar
                            </span>
                            <span>{row.level}</span>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseWifiNetworks}>Cancel</Button>
          </DialogActions>
        </Dialog>
      </TableCell>
      <TableCell align="center">
        <GiSwan
          style={{
            fontSize: "42px",
            color: "black",
            display: "inline-block",
            padding: "0.5rem",
            borderRadius: "4px",
            background: "#fff",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#f0f0f0";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
          }}
          onClick={handleClickOpenSwan}
        />
        <Dialog open={openSwan} onClose={handleCloseSwan}>
          <DialogTitle>Trigger Swan Song</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please select what action you would like to do
              <br />
              Choose "Trigger Swan Song" to get images of front and back camera
              and list of wifi networks. <br />
              Choose "Trigger search wifi networks" to get only the wifi
              networks.
              <br />
              <br />
            </DialogContentText>
            <TextField
              id="outlined-select-currency"
              autoFocus
              fullWidth
              select
              label="Data"
              helperText="Please select data type"
              onChange={(e) => setSwanMessage(e.target.value)}
              value={swanMessage}
            >
              {messages.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseSwan}>Cancel</Button>
            <Button onClick={handleSwanSongClick}>Trigger</Button>
          </DialogActions>
        </Dialog>
        {songTrigger && (
          <>
            {songTrigger.response === "Loading" ? (
              <CircularProgress size={16} />
            ) : songTrigger.response === "Success" ? (
              <Button onClick={handleSeeResultClick}>See result</Button>
            ) : (
              <Button onClick={handleSeeResultClick}>Failed</Button>
            )}
          </>
        )}
      </TableCell>
      <TableCell align="center">
        <span
          className="material-symbols-outlined"
          style={{
            color: "#1976d2",
            display: "inline-block",
            padding: "0.5rem",
            borderRadius: "4px",
            background: "#fff",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#f0f0f0";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
          }}
          onClick={triggerDeviceBeacon}
        >
          cell_tower
        </span>
        {beaconLoading === true ? (
          <CircularProgress size={16} />
        ) : (
          beaconStatus && (
            <>
              <Button onClick={beaconOpenDialog}>{beaconStatus}</Button>
              <Dialog open={beaconDialog} onClose={beaconCloseDialog}>
                <DialogTitle>Beacon UUID</DialogTitle>
                {beaconUuid && beaconStatus === "Success" && (
                  <DialogContent>
                    <DialogContentText>
                      {beaconUuid.uuid}
                      <br />
                      {new Date(beaconUuid.ts).toLocaleTimeString()}
                      <br />
                      Please notice that the Beacon is active for 5 minutes.
                      <br />
                    </DialogContentText>
                  </DialogContent>
                )}
                <DialogActions>
                  <Button onClick={beaconCloseDialog}>Cancel</Button>
                </DialogActions>
              </Dialog>
            </>
          )
        )}
      </TableCell>
    </TableRow>
  );
}

export default MissingReportSingleDevice;
